module.exports = __webpack_public_path__ + "static/media/empstate.db309750.jpg";